import { CFTokens } from '../../../../tokens';
export const CARET_COLOR = CFTokens.COLOR.TEXT_AND_ELEMENT_EMPHASIS;
export const TEXT_COLOR = {
    DEFAULT: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
    DISABLED: CFTokens.COLOR.TEXT_AND_ELEMENT_DISABLED,
    PLACEHOLDER: CFTokens.COLOR.TEXT_AND_ELEMENT_HINT,
};
export const TYPE_SPEC = {
    DEFAULT: CFTokens.TYPE_SPEC.BODY.SM,
    SM: CFTokens.TYPE_SPEC.BODY_2.SM,
    XL: CFTokens.TYPE_SPEC.BODY_LARGE.SM,
};
